import React from "react";
// Custom  Search

// Mui
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";

// Svg
import Search from "../../assets/svg/search";
import { SxProps, Theme } from "@mui/material";

const CustomSearch = ({
  value,
  onChange,
  icon,
  className,
  onClick,
  inputClassName,
  placeholder,
  sx,
  name,
  isIcon = true,
  disabled = false,
  onKeyDown,
}: {
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  icon?: React.ReactNode;
  className?: string;
  onClick?: () => void;
  inputClassName?: string;
  placeholder?: string;
  sx?: SxProps<Theme>;
  name?: string;
  isIcon?: boolean;
  disabled?: boolean;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}) => {
  return (
    <Box className={`${className} custom_search`} sx={sx}>
      <input
        className={`${inputClassName} custom_search_input`}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
        name={name}
        disabled={disabled}
        onKeyDown={onKeyDown}
      />
      {isIcon && (
        <IconButton onClick={onClick}>{icon ? icon : <Search />}</IconButton>
      )}
    </Box>
  );
};

export default CustomSearch;
